<template>
    <div class="loopInfo">
        <div class="litter">基本信息</div>
        <div class="used" v-if="getclassvalue.name&&this.$store.state.homeitem.user.roleId=='-9999'">{{getclassvalue.name}}用电</div>
        <div class="classification" v-if="editmode&&JSON.stringify(currentLoop)!='{}'">
            <el-select v-model="classvalue" placeholder="未分项" @change="changeClass">
                <el-option
                    v-for="item in classOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
            </el-select>
            <el-select v-model="looptype" placeholder="回路类型"  v-if="looptypeShow&&currentLoop.edit&&JSON.stringify(currentLoop)!='{}'">
                <el-option
                    v-for="item in looptypeOptions"
                    :key="item.id"
                    :disabled="item.disabled"
                    :label="item.name"
                    :value="item.id">
                </el-option>
            </el-select>
        </div>
        <div class="base row-center" v-if="info.device_class_id==2">
            <div class="info">
                <div class="name u-line-1">{{currentLoop.loopName}}    
                     <span class="cont" style="color:#FD4238" v-if="getLoopStatus(currentLoop)==1">合闸</span>
                    <span class="cont" style="color:#01AB65" v-else-if="getLoopStatus(currentLoop)==0">分闸</span>
                </div>
                <div class="box row-center" v-if="this.$store.getters.projectId==5&&(currentLoop.loopType=='GTI'||currentLoop.loopType=='GTO')">
                    <div class="item">
                        <div class="tt">手车位置</div>
                        <div class="cont">运行</div>
                    </div>
                    <div class="item">
                        <div class="tt">接地刀位置</div>
                        <div class="cont">断开</div>
                    </div>
                </div>
                <div class="box row-center" v-else>
                    <div class="item">
                        <div class="tt">工作位置</div>
                        <div class="cont"  v-if="mqttval('HandcarWorkingPosition')==1">工作</div>
                        <div class="cont"  v-else-if="mqttval('HandcarTestPosition')==1">试验</div>
                        <div class="cont" style="color:#999999" v-else>--</div>
                    </div>
                    <div class="item">
                        <div class="tt">合位</div>
                        <div class="cont" v-if="getLoopStatus(currentLoop)">{{getLoopStatus(currentLoop)==1?"合闸":"分闸"}}</div>
                        <div class="cont" style="color:#999999" v-else>未知</div>
                    </div>
                </div>
            </div>
            <div class="data" > 
                <div class="topic"><span>实时数据</span></div>
                <div class="box" v-if="this.$store.getters.projectId==5&&(currentLoop.loopType=='GTI'||currentLoop.loopType=='GTO')">
                    <div class="boxItem " v-for="(item,index) in details">
                        <div class="val"><span>{{item.key}}</span></div>
                        <div class="val tl" ><span>{{FalsedataA[index]}}<i> {{item.unit}}</i></span></div>
                    </div>
                </div>
                <div class="box" v-else>
                    <div class="boxItem " v-for="(item,index) in details">
                        <div class="val"><span>{{item.key}}</span></div>
                        <div class="val tl" v-if="mqttval(item.data,item.multiple)!='--'"><span>{{mqttval(item.data,item.multiple)}}<i> {{item.unit}}</i></span></div>
                        <div class="val tl grey" v-else-if="item.key"><span>--</span></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="base basedy" v-else>
            <div class="name u-line-1">{{currentLoop.loopName}}
                <span class="cont" style="color:#FD4238" v-if="(getLoopStatus(currentLoop)==1)">合闸</span>
                <span class="cont" style="color:#01AB65" v-else-if="getLoopStatus(currentLoop)==0">分闸</span>
            </div>
            <div class="data">
                <div class="topic"><span>实时数据</span></div>
                <div class="box" >
                    <div class="boxItem " v-for="(item,index) in details">
                        <div class="val"><span>{{item.key}}</span></div>
                        <div class="val tl" v-if="mqttval(item.data,item.multiple)!='--'"><span>{{mqttval(item.data,item.multiple)}}<i> {{item.unit}}</i></span></div>
                        <div class="val tl" v-else-if="item.key">
                            <span v-if="item.key=='视在功率'&&mqttval('P',0.001)!='--'&&mqttval('PR',0.001)!='--'">{{Number(Math.sqrt(Math.pow(mqttval('P',0.001),2)+Math.pow(mqttval('PR',0.001),2))).toFixed(2)}}  {{item.unit}}</span><span v-else class="grey">--</span></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="tabType">
            <span :class="breakerNum==0?'active':''" @click="breakerNum=0" v-if="currentLoop.breakDeviceId">断路器信息</span>
            <span :class="breakerNum==1?'active':''"  @click="breakerNum=1">历史曲线</span>
        </div>
        <div class="wapper" v-if="breakerNum==0">
            <div class="breaker">
                <div class="circuit row-center" >
                    <img src="@/assets/img/gy.png" alt="" v-if="info.device_class_id==2" style="transform: scale(1.2);">
                    <!-- <div v-else-if="info.device_class_id==3"> -->
                        <!-- //塑壳断路器 -->
                        <img src="@/assets/img/skdlq.png" alt="" v-if="info.device_class_id==3&&info.device_type_id==37||info.device_type_id==52"> 
                        <!-- //框架断路器 -->
                        <img src="@/assets/img/kjdlq.png" alt="" v-if="info.device_class_id==3&&info.device_type_id==36">  
                    <!-- </div> -->
                    
                    <div class="item " :class="'item'+index" v-for="(item,index) in realData" v-if="info.device_class_id==2">
                        <div class="name">{{item.key}}</div>
                        <div class="val">
                            <span v-for="(data,key,index2) in item.data"><em :class="'quare quare'+index2"></em>{{key}}:<i>{{mqttval(data)}}{{item.unit}}</i></span>
                        </div>
                    </div>
                </div>
                
                <div class="intel row-center">
                    <div class="item"><span>品牌：</span>{{info.device_brand_name}}</div>
                    <div class="item" style="text-align:right"><span>类型：</span>{{info.device_type_name}}</div>
                    <div class="item" style="width:100%"><span>型号：</span>{{info.device_model_name}}</div>
                </div>
                <div class="rated">
                    <span >额定电压： {{getQuery('额定电压')?'AC '+getQuery('额定电压'):'--'}}</span>
                    <span style="float:right" >额定电流：{{getQuery('额定电流')?'In '+getQuery('额定电流'):'--'}}</span>
                </div>
            </div>
            
            <div class="switching">
                <div class="box row-center" v-if="this.$store.getters.projectId==5&&(currentLoop.loopType=='GTI'||currentLoop.loopType=='GTO')">
                    <div class="item column-center">
                        <div class="tt">断路器位置</div>
                        <div class="cont" style="color:#FD4238">合闸</div>
                    </div>
                    <div class="item column-center">
                        <div class="tt">弹簧储能</div>
                        <div class="cont">已储能</div>
                    </div>
                </div>
                <div class="box row-center" v-else>
                    <div class="item column-center">
                        <div class="tt">合分闸状态</div>
                        <div class="cont" style="color:#FD4238" v-if="getLoopStatus(currentLoop)==1||currentLoop.loopId==205||currentLoop.loopId==297||currentLoop.loopId==1566||currentLoop.loopId==1567">合闸</div>
                        <div class="cont" style="color:#01AB65" v-else-if="getLoopStatus(currentLoop)==0">分闸</div>
                        <div class="cont grey" v-else>--</div>
                    </div>
                    <div class="item column-center">
                        <div class="tt">弹簧储能</div>
                        <div class="cont" style="color:#999999">未知</div>
                    </div>
                </div>
                <CircuitBreakerAging  :currentLoop="currentLoop" :currInfo="info" :data="mqttval('Contact_wear')"></CircuitBreakerAging>
            </div>
        </div>
        <!-- 2高压  3低压-->
        <div class="Historical" v-else-if="breakerNum==1&&info.device_class_id===3">   
            <Historical :currentLoop="currentLoop" :devicetype="info.device_class_id" ></Historical>  
        </div>
        <div class="Historical" v-else-if="breakerNum==1&&info.device_class_id===2">  
            <LowDiagram :currentLoop="currentLoop" :devicetype="info.device_class_id" :device_category_id="info.device_category_id"></LowDiagram>
        </div>
        <div v-else-if="!info.device_class_id" style="text-align:center;margin-top:120px">
            <img  src="@/assets/img/not_found_data.png" alt=""/>
        </div>
    </div>
</template>

<script>
import { deviceAll,loopList,GetWireByDeviceID,loopUpdate } from "../../api/power";
import { floatFormat } from "../../util/MathUtil";
import CircuitBreakerAging from "./components/CircuitBreakerAging.vue";
import Historical from "./components/Historical.vue";
import LowDiagram from "./components/LowDiagram.vue";
  export default {
    props:{
        currentLoop:Object,
        disabledIn:Boolean, //是否隐藏进线
        looptypeShow:Boolean,  //回路类型
        editmode:Boolean, 
        GTOShow:Boolean  //是否显示高压
    },
    components:{
        CircuitBreakerAging,Historical,LowDiagram
    },
    data() {
      return {
        info:{},
        breakerNum:0,
        realData:[
            {
                key: "上触臂温度",
                unit: "℃",
                data: {
                    'A相': "temperature_lower_a",
                    'B相': "temperature_lower_b",
                    'C相': "temperature_lower_c",
                }
            },
            {
                key: "下触臂温度",
                unit: "℃",
                data: {
                    'A相': "temperature_lower_a",
                    'B相': "temperature_lower_b",
                    'C相': "temperature_lower_c",
                },
            }
        ],
        FalsedataA:["5.2","10.2",'5.6','10.6','6.2','10.4'],
        classvalue:"",
        getclassvalue:"",
        classOptions:[
            {
                id:1,
                name:"空调"
            },{
                id:2,
                name:"照明"
            },{
                id:3,
                name:"动力"
            },{
                id:4,
                name:"特殊"
            },
        ],
        looptype:"",  //选择回路类型
        looptypeOptions:[
            {
                id:"GTI",
                disabled:false,
                name:"高压进线（GTI）"
            },{
                id:"GTO",
                disabled:false,
                name:"高压出线（GTO）"
            },{
                id:"IN",
                disabled:false,
                name:"低压进线（IN）"
            }
        ],
      };
    },
    computed:{
        projectId(){
            return this.$store.getters.projectId
        },
        details(){
            if(this.info.device_class_id==2){ //高压
                return [
                    {
                        key: "A相电压",
                        unit: "kV",
                        // multiple: 0.001,
                        data:"Ua"
                    },
                    {
                        key: "A相电流",
                        unit: "A",
                        data:"Ia"
                    },
                    {
                        key: "B相电压",
                        unit: "kV",
                        // multiple: 0.001,
                        data:"Ub"
                    },
                    {
                        key: "B相电流",
                        unit: "A",
                        data:"Ib"
                    },
                    {
                        key: "C相电压",
                        unit: "kV",
                        // multiple: 0.001,
                        data:"Uc"
                    },
                    {
                        key: "C相电流",
                        unit: "A",
                        data:"Ic"
                    }
                ]
            }else{
                return [
                    {
                        key: "A相电流",
                        unit: "A",
                        data:"Ia"
                    },
                    {
                        key: "A相电压",
                        unit: "V",
                        // multiple: 0.001,
                        data:"Ua"
                    },
                    {
                        key: "AB线电压",
                        unit: "V",
                        // multiple: 0.001,
                        data:"Uab"
                    },
                    {
                        key: "有功功率",
                        unit: "kW",
                        multiple: 0.001,
                        data:"P"
                    },
                    {
                        key: "功率因数",
                        unit: "",
                        data:"PF"
                    },
                    {
                        key: "B相电流",
                        unit: "A",
                        data:"Ib"
                    },
                    {
                        key: "B相电压",
                        unit: "V",
                        // multiple: 0.001,
                        data:"Ub"
                    },
                    {
                        key: "BC线电压",
                        unit: "V",
                        // multiple: 0.001,
                        data:"Ubc"
                    },
                    {
                        key: "无功功率",
                        unit: "kVar",
                        multiple: 0.001,
                        data:"PR"
                    },
                    {
                        key: "频率",
                        unit: "Hz",
                        data:"F"
                    },
                    {
                        key: "C相电流",
                        unit: "A",
                        data:"Ic"
                    },
                    {
                        key: "C相电压",
                        unit: "V",
                        // multiple: 0.001,
                        data:"Uc"
                    },
                    {
                        key: "CA线电压",
                        unit: "V",
                        // multiple: 0.001,
                        data:"Uac"
                    },
                    {
                        key: "视在功率",
                        unit: "kVA",
                        multiple: 0.001,
                        data:"PA"
                    },
                    {
                        key: "",
                        unit: "",
                        multiple: 0.001,
                        data:""
                    }
                ]
            }
        },
        getLoopStatus(tpl) {
            return function (value) {
                return this.$store.getters.mqttVal(value.subLoopUrl + "/SwitchOn");
            };
        },
        mqttval() {
			return this.getMqttVal(this.$store.getters.mqttVal);
		},
        getQuery(){
            return function(name){
                let data = this.info.device_details
                for (let arr in data) {
                    for (const [key, value] of Object.entries(data[arr])) {
                        if(key==name){
                            return value
                        }
                        // console.log(`${key}: ${value}`);
                    }
                }
            }
        },
        
    },
    watch:{
        currentLoop(n,o){
            this.initGetWireByDeviceID();
            if(n.itemId!=undefined){
                this.classvalue = this.currentLoop.itemId
                this.getclassvalue = this.classOptions.filter(e=>e.id==this.classvalue)[0]
            }else{
                this.classvalue = ""
                this.getclassvalue = ""
            }
            this.loopType = n.loopType
            if(n.isadd){
                this.looptype = ""
            }
        },
        looptype(n,o){
            this.$emit("loopType",n)
        },
        // disabledIn(n,o){
        //     this.looptypeOptions[2].disabled = n
        // },
        // GTOShow(n,o){
        //     this.looptypeOptions[0].disabled = !n
        //     this.looptypeOptions[1].disabled = !n
        // }
    },
    mounted(){
        this.loopType = this.currentLoop.loopType
        if(this.currentLoop.itemId!=undefined){
            this.classvalue = this.currentLoop.itemId
        }else{
            this.classvalue = ""
        }
        // if(this.disabledIn){
        //     this.looptypeOptions[2].disabled = true
        // }
        // if(this.GTOShow){
        //     this.looptypeOptions[0].disabled = false
        //     this.looptypeOptions[1].disabled = false
        // }else{
        //     this.looptypeOptions[0].disabled = true
        //     this.looptypeOptions[1].disabled = true
        // }
        this.initGetWireByDeviceID();
    },
    methods:{
        async changeClass(){
            let obj = {
                loopName:this.currentLoop.loopName,
                loopId:this.currentLoop.loopId,
                itemId:this.classvalue
            }
            let result = await loopUpdate(obj);
            if(result.data.status){
                this.$message.success('保存成功！');
                this.$emit("upadteItemId",this.currentLoop)
            }
        },
        getMqttVal(f) {
			return (k, m) => {
				if (this.currentLoop && k) {
					k = this.currentLoop.subLoopUrl + "/" + k;
                    let mqttVal = f(k);
                    if (m) {
                        mqttVal *= m;
                    }
                    mqttVal = floatFormat(mqttVal, 2);
                    if (typeof mqttVal === "object") {
                        return mqttVal;
                    }
                    return mqttVal !== undefined && !isNaN(mqttVal) ? mqttVal : "--";
                } else {
                    return "--";
				}
			};
		},
        async initGetWireByDeviceID(){
            // if(this.currentLoop.breakDeviceId){
                let id = this.currentLoop.breakDeviceId
                if(!this.currentLoop.breakDeviceId){ //没有断路器
                    this.breakerNum = 1
                    id = this.currentLoop.deviceId
                }else{
                    this.breakerNum = 0
                }
                let result = await GetWireByDeviceID(id);
                let data = result.data.data.device
                if(data){
                    data.device_details = JSON.parse(data.device_details)
                    this.info = data
                }else{
                    this.info = {}
                }
               
            // }else{
            //     this.info = {}
            //     this.breakerNum = 1
            // }
            
        },
    }
  };
</script>

<style scoped lang="less">
.used{
    position: absolute;
    right:30px;
    top: 38px;
    background: url("../../assets/img/arrow.png") no-repeat;
    width: 77px;
    height:27px;
    line-height: 27px;
    color:#FFFFFF;
    font-size: 14px;
    text-align: right;
    padding-right: 5px;

}
.classification{
    position: absolute;
    right:30px;
    top: 35px;
    /deep/.el-input__inner{
        width:130px;
    }
    /deep/.el-select{
        margin-left: 10px;
    }

}
.loopInfo{
    width: 100%;
    height: 100%;
    overflow: auto;
    .litter{
        font-size: 18rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
        padding-bottom: 0.6vh;
        border-bottom:1px solid rgba(0, 0, 0, 0.15) ;
        padding-left: 0.7vw;
        position: relative;
        color: #0D94FF;
        &::before{
            content:'';
            width: 5rem;
            height: 2vh;
            background-color: #0D94FF;
            position: absolute;
            top: 40%;
            left: 0;
            transform: translate(0, -50%);
        }
    }
    .base{
        width: 100%;
        justify-content: space-between;
        .h(230);
        overflow: hidden;
        // margin-bottom: 20rem;
        .name{
            font-size: 30rem;
            font-weight: bold;
            color: #666666;
            margin: 10rem 0;
            height: 39rem;
        }
        .info{
            height: 95%;
            .w(420);
            .box{
                height: 110px;
                // .h(110);
                background: rgba(0, 43, 102, 0.04);
                border-radius: 4rem;
                justify-content: space-around;
                text-align: center;
                .item{
                    .cont{
                        font-size: 24rem;
                        color: #0D94FF;
                        font-weight: 600;
                    }
                    .tt{
                        font-size: 18rem;
                        margin-bottom: 10rem;
                    }
                    
                }
            }
        }
        .data{
            .w(372);
            .topic{
                span{
                    font-size: 16rem;
                    font-weight: bold;
                    color: #0D94FF;
                    display: inline-block;
                    border-bottom: 2px solid #0D94FF;
                    line-height: 35rem;
                    margin-left: 15px;
                }
            }
            .box{
                width: 100%;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                border-top:1px solid rgba(0, 0, 0, 0.15) ;
                // border-left: 1px solid rgba(0, 0, 0, 0.15);
                border-right: 1px solid rgba(0, 0, 0, 0.15);
                .boxItem{
                    width: 50%;
                    display: flex;
                    height: 42rem;
                    line-height: 42rem;
                    text-align: center;
                    border-left: 1px solid rgba(0, 0, 0, 0.15);
                    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
                    .val{
                        width: 50%;
                        height: 100%;
                        background:#F5F7F9 ;
                        position: relative;
                        font-size: 16rem;
                        white-space: nowrap;
                        font-family: Source Han Sans CN;
                        font-weight: bold;
                        color: #333333;
                        text-align: left;
                        padding-left: 15rem;
                    }
                    .tl{
                        text-align: left;
                        padding-left: 5px;
                    }
                    .val:nth-child(2){
                        background:#fff ;
                        color: #0D94FF;
                        font-size: 18rem;
                    }
                }
                // .border{
                //     border-right: 1px solid rgba(0, 0, 0, 0.15);
                // }
                // .boxItem:nth-child(odd){
                //     border-left: 1px solid rgba(0, 0, 0, 0.15);
                //     border-bottom: 1px solid rgba(0, 0, 0, 0.15);
                //     border-right: 1px solid rgba(0, 0, 0, 0.15);
                // }
                // .boxItem:nth-child(even){
                //     border-bottom: 1px solid rgba(0, 0, 0, 0.15);
                //     border-right: 1px solid rgba(0, 0, 0, 0.15);
                // }
            }
            
            // .box:last-child{
            //     border-bottom:1px solid rgba(0, 0, 0, 0.15) ;
            // }
        }
    }
    .basedy {
        // height:auto !important;
        margin-bottom: 10px;
        .data{
            width: 100%;
            margin-top: -10rem;
            .boxItem{
                width:20% !important
            }
        }
    }
    .tabType{
        border-bottom: 1px solid rgba(0, 0, 0, 0.15);
        padding-bottom: 0.6vh;
        position: relative;
        &>span{
            display: inline-block;
            padding-left: 0.7vw;
            margin-right: 1vw;
            font-size: 18rem;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
            position: relative;
            cursor: pointer;
            
        }
        .active{
            color: #0D94FF;
        }
    }
    .tabType::before{
        content:'';
        width: 5px;
        height: 2vh;
        background-color: #0D94FF;
        position: absolute;
        top: 40%;
        left: 0;
        transform: translate(0, -50%);
    }
    .wapper{
        display: flex;
        margin-top: 20rem;
        width: 100%;
    }
    .Historical{
        margin-top: 20rem;
        width: 100%;
    }
    .breaker{
        // display: flex;
        .w(478);
        .circuit{
            .w(400);
            .h(400);
            background: #FFFFFF;
            border: 1px solid #E5E5E5;
            box-shadow: 0px 0px 16px 0px rgba(0,43,102,0.08);
            text-align: center;
            overflow: hidden;
            position: relative;
            img{
                max-width: 100%;
                max-height: 100%;
            }
            .item{
                position: absolute;
                // -webkit-text-stroke: 1px #FFFFFF;
                // text-stroke: 1px  #FFFFFF;
                left:18%;
                top:20%;
                font-size: 16px;
                text-align: left;
                // letter-spacing: 2px;
                font-weight: bold;text-shadow: #fff 2px 0 0, #fff 0 2px 0, #fff -2px 0 0, #fff 0 -2px 0;
                i{
                    color:#0D94FF
                }
                .quare{
                    width: 15px;
                    height: 15px;
                    background: #E8684A;
                    border: 2px solid #FFFFFF;
                    border-radius: 50%;
                    display: inline-block;
                    margin-right: 2px;
                    vertical-align: -1px;
                }
                .quare1{
                    background: #5AD8A6;
                }
                .quare2{
                    background: #F6BD16;
                }
                .name{
                    margin-bottom: 5px;
                }
                span{
                    margin: 0 5px;
                }
            }
            .item1{
                top:55%
            }
        }
        .intel{
            font-size: 24rem;
            font-family: Source Han Sans CN;
            font-weight: bold; 
            justify-content: flex-start;
            .h(80);
            margin:20rem 0 10rem 0;
            .item{
                width: 50%;
            }
            span{
                color: #666666;
            }
        }
        .rated{
            font-size: 18rem;
            font-weight: 400;
            color: #666666;
            border-top: 1px solid #CCCCCC;
            line-height: 50rem;
        }
    }
    
    .switching{
        flex: 1;
        padding-left: 20rem;
        .box{
            justify-content: space-between;
            text-align: center;
            .item{
                background: rgba(0, 43, 102, 0.04);
                border-radius: 4px;
                // .w(178);
                width:48%;
                .h(188);
                .cont{
                    font-size: 35rem;
                    color: #0D94FF;
                    font-weight: 600;
                }
                .tt{
                    font-size: 24rem;
                    margin-bottom: 20rem;
                    font-weight: bold;
                }
                
            }
        }
    }
}
</style>